<template>
    <FullFillBox
        :pageID="1009"
        :otherPer="[3]"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
        @otherPermission="(data) => {
            if(data[0].status === 80){
                this.exportButtonCanSpawn = true
            }
        }"
    >
        <h4>{{ $t('inventory_log') }}</h4>
        <hr>
        <div class="row">
            <div class="col-lg-10">
                <div class="row">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-lg-4 col-form-label">
                                {{ $t('common_start') }}
                            </div>
                            <div class="col-lg-8">
                                <input class="form-control"
                                       type="datetime-local" id="start-time"
                                       v-model="startDate"
                                       min="2022-11-01T00:00"
                                       @change="getBackendData">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-lg-4 col-form-label">
                                {{ $t('common_end') }}
                            </div>
                            <div class="col-lg-8">
                                <input class="form-control"
                                       type="datetime-local" id="end-time"
                                       v-model="endDate"
                                       min="2022-11-01T00:00"
                                       @change="getBackendData">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row p-1 g-1">
                            <div class="col-6"><button class="btn btn-primary" @click="resetTimeFilter">{{ $t('common_reset') }}</button></div>
                            <div class="col-6"><button class="btn btn-primary" @click="getExportExcel">{{ $t('common_export_excel') }}</button></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
                <select class="form-select" v-model="groupBy" @change="tableGroupBy">
                    <option value="no">{{ $t('inventory_table_gp_no_gp') }}</option>
                    <option value="key">{{ $t('table_key') }}</option>
                    <option value="loc">{{ $t('inventory_table_gp_loc') }}</option>
                    <option value="outCode">{{ $t('inventory_table_gp_outCode') }}</option>
                    <option value="cat">{{ $t('product_category') }}</option>
                    <option value="brand">{{ $t('product_brand') }}</option>
                    <option value="size">{{ $t('product_size_gp') }}</option>
                    <option value="color">{{ $t('product_color') }}</option>
                    <option value="material">{{ $t('product_material') }}</option>
                </select>
            </div>
        </div>
        <hr>
        <ProductFilterMultiSelect
            :mainData="mainData"
            ref="filterBar"
            v-if="mainData"
            @getFilteredData="(data) => {
                    this.subTable.setData(data)
                    this.subTable.redraw(true)
                }"
        />
        <hr>
        <div ref="tabulatorTableUse"></div>
        <hr>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import OtherDetailsEditPopUp from "@/components/OtherDetailsEditPopUp.vue";
import ProductFilterMultiSelect from "@/components/ProductFilterMultiSelect.vue";

export default {
    name: "InventoryLogView",
    components: {
        ProductFilterMultiSelect,
        OtherDetailsEditPopUp,
        FullFillBox,
        Multiselect,
    },
    data(){
        return{
            permissionDetails: {},
            exportButtonCanSpawn: false,
            groupBy: 'no',

            startDate: '',
            endDate: '',

            getCategory: [],
            getBrand: [],
            categoryList: [],
            brandList: [],
            mainData: [],

            tabulatorTables2: [],
        }
    },
    methods: {
        async getExportExcel(){
            await this.$swal.fire({
                title: this.$t('inventory_export'),
                html:
                    `
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon2">${this.$t('inventory_export_type_select')}</span>
                        <select class="form-control" id="swal-select-type">
                            <option value="all" selected>${this.$t('inventory_export_type_all')}</option>
                            <option value="stockIn">${this.$t('inventory_export_type_stockIn')}</option>
                            <option value="stockOut">${this.$t('inventory_export_type_stockOut')}</option>
                            <option value="transfer">${this.$t('inventory_export_type_transfer')}</option>
                            <option value="transferIn">${this.$t('inventory_export_type_transferIn')}</option>
                            <option value="transferOut">${this.$t('inventory_export_type_transferOut')}</option>
                            <option value="writeOff">${this.$t('inventory_export_type_writeOff')}</option>
                            <option value="adjustment">${this.$t('inventory_export_type_adjustment')}</option>
                        </select>
                    </div>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon3">${this.$t('common_start')}</span>
                        <input class="form-control" id="swal-input-start-date" type="datetime-local" value="${this.startDate}">
                    </div>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon3">${this.$t('common_end')}</span>
                        <input class="form-control" id="swal-input-end-date" type="datetime-local" value="${this.endDate}">
                    </div>
                `,
                focusConfirm: false,
                allowEnterKey: true,
                showCancelButton: true,
                confirmButtonText: this.$t('common_download'),
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    let getType = document.getElementById('swal-select-type').value
                    let getStartDate = document.getElementById('swal-input-start-date').value
                    let getEndDate = document.getElementById('swal-input-end-date').value

                    let timeUrl = getStartDate ? `&start=${getStartDate}` : ''
                    timeUrl += getEndDate ? `&end=${getEndDate}` : ''

                    await this.$mainApi.get(`api/inventory/log/excel?type=${getType}${timeUrl}`)
                        .then(response => {
                            console.log(response.data)
                            if(response.data.status === 80){
                                location.href = (this.$store.state.serverIp + response.data.details)
                            }
                        })
                    return true
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            })
        },
        filterSelected(){
            let nowTableData = this.mainData
            if(this.getCategory.length > 0 && this.getBrand.length > 0){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name) || this.getBrand.includes(a.brand_name))
            }
            if(this.getCategory.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getCategory.includes(a.category_name))
            }
            if(this.getBrand.length > 0 ){
                nowTableData = nowTableData.filter(a => this.getBrand.includes(a.brand_name))
            }
            this.subTable.setData(nowTableData)
            this.subTable.redraw()
        },
        resetTimeFilter(){
            this.startDate = ""
            this.endDate = ""
            this.getBackendData()
        },
        tableGroupBy(){
            if(this.groupBy === "no"){
                this.subTable.setGroupBy("")
                this.subTable.setSort("createDate", "desc");
            }else if(this.groupBy === "key"){
                this.subTable.setGroupBy("keyName")
                this.subTable.setSort("createDate", "desc");
            }else if(this.groupBy === "outCode"){
                this.subTable.setGroupBy("outCode")
                this.subTable.setSort("outCode", "asc");
            }else if(this.groupBy === "loc"){
                this.subTable.setGroupBy("location")
                this.subTable.setSort("location", "asc");
            }else if(this.groupBy === "cat"){
                this.subTable.setGroupBy("category_name")
                this.subTable.setSort("category_name", "asc");
            }else if(this.groupBy === "brand"){
                this.subTable.setGroupBy("brand_name")
                this.subTable.setSort("brand_name", "asc");
            }else if(this.groupBy === "size"){
                this.subTable.setGroupBy("size_group")
                this.subTable.setSort("size_group", "asc");
            }else if(this.groupBy === "color"){
                this.subTable.setGroupBy("color")
                this.subTable.setSort("color", "asc");
            }else if(this.groupBy === "material"){
                this.subTable.setGroupBy("material")
                this.subTable.setSort("material", "asc");
            }
            this.subTable.redraw()
        },
        async getFilterData(){
            await this.$mainApi.get('api/product/filter/')
                .then(response => {
                    if(response.data.status === 80){
                        // 1 -> Category, 2 -> Brand
                        this.categoryList = response.data.details[0]["1"]
                        this.brandList = response.data.details[1]["2"]
                    }
                })
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.subTable)
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            let extraPath = ""
            if(this.startDate){
                extraPath += `?start=${this.startDate}`
            }
            if(this.endDate){
                if(extraPath.length > 4){
                    extraPath += `&end=${this.endDate}`
                }else{
                    extraPath += `?end=${this.endDate}`
                }
            }
            await this.$mainApi.get(`api/inventory/log${extraPath}`)
                .then(response => {
                    if(response.data.status === 80){
                        this.mainData = response.data.details
                        this.subTable.setData(this.mainData)
                        this.subTable.redraw()
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        }
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_log')

        this.subTable = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            height: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            data: [],
            columns: [
                {formatter: 'rownum', width: 50, minWidth: 50, maxWidth: 50, responsive:0},
                {
                    responsive:5, widthGrow:1,
                    title: this.$t('table_create_date'),
                    field: "createDate",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:5, width: 150,
                    title: this.$t('table_ip'),
                    field: "ip",
                    sorter: "string", visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:5, widthGrow:1,
                    title: this.$t('table_show_name'),
                    field: "show_name",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:5, widthGrow:1,
                    title: this.$t('table_action'),
                    field: "action_name",
                    sorter: "string",
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                    formatter: (cell, formatterParams, onRendered) => {
                        if(cell.getValue() === 'Stock In' || cell.getValue() === 'Transfer In'){
                            return "<span style='color: #11e100'>" + cell.getValue() + "</span>"
                        }if(cell.getValue() === 'Stock Out' || cell.getValue() === 'Transfer Out' || cell.getValue() === 'Write Off'){
                            return "<span style='color: #eb2525'>" + cell.getValue() + "</span>"
                        }else{
                            return "<span style='color: #000000'>" + cell.getValue() + "</span>"
                        }
                    },
                },
                {
                    widthGrow:3, responsive:5,
                    title: this.$t('table_key'), formatter: 'textarea',
                    field: "keyName",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                    cellMouseEnter: (e, cell) => {
                        cell.getElement().style.color = '#ff00d5'
                    },
                    cellMouseLeave: (e, cell) => {
                        cell.getElement().style.color = '#424242'
                    },
                    cellDblClick:async (e, cell, formatterParams) => {
                        if(this.exportButtonCanSpawn){
                            await this.$mainApi.get(`api/inventory/export-key?action=${cell.getRow().getData().actionCode}&name=${cell.getRow().getData().keyName}`)
                                .then(response => {
                                    if (response.data.status === 80) {
                                        location.href = (this.$store.state.serverIp + response.data.details)
                                    } else {
                                        this.$swal.fire({
                                            title: response.data.errors,
                                            text: response.data.details,
                                            icon: 'warning'
                                        })
                                    }
                                })
                        }else{
                            this.$toast.error(this.$t('error_no_permission'))
                        }
                    },
                },
                {
                    widthGrow:1, responsive:3,
                    title: this.$t('table_key_remarks'),
                    field: "keyRemarks", visible: false,
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:0, widthGrow:1,
                    title: this.$t('table_location'),
                    field: "location",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    responsive:1, widthGrow:1,
                    title: this.$t('table_qty'),
                    field: "qty",
                    sorter: "number",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:2, width:200, responsive:0,
                    title: this.$t('product_outCode_short'),
                    field: "outCode",
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    widthGrow:2, width:200, responsive:0,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    widthGrow:2, width:300, responsive:3, formatter: 'textarea',
                    title: this.$t('product_product_en'),
                    field: this.$store.state.language === 'en' ? 'name_en' : 'name_zh',
                    sorter: "string",
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {field: "keyID", visible: false},
                {field: "hisID", visible: false},
                {field: "actionCode", visible: false},
                {
                    title: this.$t('table_category'), field: 'category_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, minWidth: 100, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_brand'), field: 'brand_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size'), field: 'size_group', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size_detail'), field: 'size_detail', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_size_remarks'), field: 'size_remarks', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_color'), field: 'color', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_material'), field: 'material', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_inner_packing'), field: 'in_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_unit1', field: 'in_unit1', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_unit2', field: 'in_unit2', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_unit1', field: 'out_unit1', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_unit2', field: 'out_unit2', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'min_stock', field: 'min_stock', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_length', field: 'in_size_length', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_width', field: 'in_size_width', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_height', field: 'in_size_height', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_length', field: 'out_size_length', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_width', field: 'out_size_width', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_height', field: 'out_size_height', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'net_weight', field: 'net_weight', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'gross_weight', field: 'gross_weight', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'flag', field: 'flag', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    formatter: (cell, formatterParams, onRendered) => {
                        return "<i class='bi bi-plus-circle-fill'></i>"
                        // let data = cell.getRow(cell).getData().actionCode
                        // if(data === 1 || data === 2){
                        //     return "<i class='bi bi-plus-circle-fill'></i>"
                        // }
                    },
                    headerMenu: this.getHeaderMenu,
                    headerHozAlign: "center",
                    hozAlign: "center",
                    vertAlign: "middle",
                    resizable: false,
                    headerSort: false,
                    width: 10,
                    responsive: 0,
                    cellClick:
                        (e, row, formatterParams) => {
                            // if(row.getData().actionCode === 1 || row.getData().actionCode === 2){
                            const id = row.getData().hisID;
                            let parent = document.getElementById("subParent2-" + id + "")

                            if (parent.style.display === "none") {
                                parent.style.display = 'block'

                                let mainContainer = document.createElement("div")
                                parent.appendChild(mainContainer);
                                mainContainer.setAttribute('id', 'mainContainer2' + id)
                                mainContainer.style.textAlign = "center"

                                let loading = document.createElement("div")
                                mainContainer.appendChild(loading);
                                loading.setAttribute('class', 'spinner-grow')
                                loading.setAttribute('role', 'status')

                                let tableEl = document.createElement("div");
                                mainContainer.appendChild(tableEl);
                                tableEl.style.border = "1px solid #333";
                                tableEl.style.margin = "auto";
                                tableEl.setAttribute('id', "subTableID2-" + id + "");
                                tableEl.setAttribute('class', "subTable2");

                                loading.remove()

                                let rowColor = ""
                                let getColumn = []
                                let getData = []
                                if(row.getData().actionCode === 1){
                                    rowColor = "#dbffaf"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "remarks",
                                        },
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_lot_no'),
                                            field: "lot_no",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_origin'),
                                            field: "origin",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_cost'),
                                            field: "cost",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return "<span style='color: #000000'>$&nbsp;" + cell.getValue() + "</span>"
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 0, minWidth: 100,
                                            title: this.$t('table_receive'),
                                            field: "receiveDate",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 0, minWidth: 100,
                                            title: this.$t('table_expiry'),
                                            field: "expiryDate",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        }
                                    ]
                                    getData.push({
                                        "remarks": row.getData().remarks,
                                        "lot_no": row.getData().lot_no,
                                        "origin": row.getData().origin,
                                        "cost": row.getData().cost,
                                        "receiveDate": row.getData().receiveDate,
                                        "expiryDate": row.getData().expiryDate
                                    })
                                }else if(row.getData().actionCode === 2){
                                    rowColor = "#bbd0ff"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "remarks",
                                        },
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_stock_out_date'),
                                            field: "lot_no",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_stock_out_driver'),
                                            field: "origin",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return cell.getValue()
                                                }
                                            }
                                        },
                                        {
                                            widthGrow: 1, responsive: 2, minWidth: 100,
                                            title: this.$t('table_stock_out_department'),
                                            field: "cost",
                                            formatter: (cell, formatterParams, onRendered) => {
                                                if (cell.getValue() === 0 || cell.getValue() ==="0") {
                                                    return "<span style='color: #000000'>" + this.$t('common_no_data') + "</span>"
                                                }else{
                                                    return "<span style='color: #000000'>" + cell.getValue() + "</span>"
                                                }
                                            }
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().remarks,
                                        "lot_no": row.getData().lot_no,
                                        "origin": row.getData().origin,
                                        "cost": row.getData().cost,
                                    })
                                }else if(row.getData().actionCode === 3 || row.getData().actionCode === 4){
                                    rowColor = "#ffdfbb"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "remarks",
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().remarks,
                                    })
                                }else if(row.getData().actionCode === 5){
                                    rowColor = "#f4c9ff"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "remarks",
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().remarks,
                                    })
                                }else if(row.getData().actionCode === 6){
                                    rowColor = "#ffffff"
                                    getColumn = [
                                        {
                                            widthGrow: 1, responsive: 3, minWidth: 100,
                                            title: this.$t('table_remarks'),
                                            field: "remarks",
                                        },
                                    ]
                                    getData.push({
                                        "remarks": row.getData().remarks,
                                    })
                                }

                                this.subTable2 = new Tabulator(tableEl, {
                                    placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                                    maxHeight: '20vh',
                                    responsiveLayout: 'collapse',
                                    layout: "fitColumns",
                                    movableColumns: true,
                                    movableRows: false,
                                    rowFormatter: (row, e) => {
                                        row.getElement().style.backgroundColor = rowColor
                                    },
                                    data: getData,
                                    columns: getColumn,
                                })

                                this.tabulatorTables2.push(
                                    {
                                        "hisId": id,
                                        "table": this.subTable2
                                    }
                                )
                            }else{
                                this.tabulatorTables2 = this.tabulatorTables2.filter(a => a.hisId !== parseInt(id))
                                document.getElementById("mainContainer2" + id).remove()
                                parent.style.display='none'
                            }
                        }
                }
            ],
            rowFormatter: (row, e) => {
                if (row.getData().actionCode === 1) {
                    row.getElement().style.backgroundColor = "#dbffaf"
                }
                if (row.getData().actionCode === 2) {
                    row.getElement().style.backgroundColor = "#bbd0ff"
                }
                if (row.getData().actionCode === 3 && row.getData().qty > 0) {
                    row.getElement().style.backgroundColor = "#ffedb4"
                }
                if (row.getData().actionCode === 4 && row.getData().qty < 0) {
                    row.getElement().style.backgroundColor = "#ffd6d6"
                }
                if (row.getData().actionCode === 5) {
                    row.getElement().style.backgroundColor = "#f4c9ff"
                }
                //create and style holder elements
                let holderEl = document.createElement("div");

                const subTableHis = row.getData().hisID;

                holderEl.style.display = "none";
                holderEl.style.boxSizing = "border-box";
                holderEl.style.padding = "10px 10px 10px 10px";
                holderEl.style.borderTop = "1px solid #333";
                holderEl.style.borderBotom = "1px solid #333";
                holderEl.style.width = "90vw";
                holderEl.style.background = "#ffffff";

                holderEl.setAttribute('id', "subParent2-" + subTableHis + "");
                holderEl.setAttribute('class', "subParent2");

                row.getElement().appendChild(holderEl);
            }
        })
        this.getFilterData()
        this.getBackendData()
    }
}
</script>

<style scoped>

</style>
